import api from "@/services/api.service";

export default {
  name: 'trash-list',
  components: {},
  props: {
    caption: {
      type: String,
      default: "Trash Contact List"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    icon: 'fa fa-sort',
    selcol: '',
    items: [],
    fields: [
    { key: "#", stickyColumn: true },
    { key: "actions", stickyColumn: true } ],
    sech: {},
    currentPage: 1,
    perPage: 10,
    perPageNew: 1,
    totalRows: null,
    totalTrashContact: null,
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    isApproved : true,
    colName : ''
    }
  },
  computed: {

  },
  mounted () {

  },
  created() {
    this.getTrashContacts();
  },
  watch: {
    currentPage: {
      handler: function(page) {         
          this.getTrashContacts(page);
      }
    },
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    selectAll: function(e) {
      this.delete_ids = [];  
      if(e.target.checked){
        for (var item in this.items) {
          this.delete_ids.push(this.items[item].id.toString());
        }                
      }            
    },
    selectOne(){
      this.allSelected = false;            
    },
    async getTrashContacts(page) {
      this.items = [];    
      this.sech.page = page;
      this.sech.paginateVal = this.perPage;
      let response = await api.post("admin/duplicate-contact/trash-list", this.sech);
      if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[response.data.data[0]]));

        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: true}) 
       });

        //Iterate Data 
        response.data.data.forEach( function(element) {                    
    
            var someObject = Object.assign({}, element )
            this.items.push(someObject);  
    
        }.bind(this));
        this.totalTrashContact = response.data.total;  
        this.currentPage = response.data.current_page;
        this.perPage = response.data.per_page;

        this.pageOptions.forEach(element => {
          if(element.value > this.totalTrashContact){
              var indexOf = this.pageOptions.indexOf(element);
              if( indexOf != 0 )
              this.pageOptions.splice(indexOf)
          }
        });
        if(this.totalTrashContact <= 500)
        this.pageOptions.push({text:'All',value:this.totalTrashContact});
      } else {
        this.items = [];
        this.fields = [];
      }
    }else{
      this.makeToast(response.message, 'Alert', 'warning', 6000);
      // this.$router.push({name: "List Event"});
    }      
    this.isBusy = false;
    },
    multipleDelete(){
      this.$bvModal
      .msgBoxConfirm("Are you sure want to restore this Contacts?")
      .then(value => {
        if (value) {
          this.restoreContact(this.delete_ids);
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    },singleDelete(id) {
      this.$bvModal
      .msgBoxConfirm("Are you sure want to restore this Contact?")
      .then(value => {
        if (value) {
          this.restoreContact(id);
        } else {
          return;
        }
      })
      .catch(function() {
        return;
      });
    },
    async restoreContact(id){
      let response = await api.post("admin/duplicate-contact/trash-restore",{id : id });
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
  
      if (response.status == "success") {
        this.items = [];
        this.makeToast(`Contact restored successful.`,"success","success");
        this.getTrashContacts();
      } else{
        for (var error in response.errors)
          this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
      } 
    }
  
  }

}


